import React from 'react';
import PropTypes from 'prop-types';
import DataTable from '../../../../components/DataTable';
import Title from '../../../../components/Title';
import FilterBar from './FilterBar';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const uri = '/api/v1/health_clinic/list';

const initialParams = {
  sort: 'id_health_clinic|DESC',
};

function Files(props) {
  const { history } = props;
  const [params, setParams] = React.useState(initialParams);

  function handleFilter(parms) {
    setParams({ ...initialParams, ...parms });
  }

  function handleEdit(row) {
    history.push(`/salud/archivos/editar/1`);
  }

  const ActionButtons = [
    {
      label: 'Editar',
      icon: 'create',
      color: 'primary',
      callback: handleEdit,
    },
  ];

  const tableHeaders = [
    { name: 'description', label: 'Nombre' },
    { name: 'address', label: 'Dirección' },
    { name: 'phone', label: 'Teléfono' },
    { name: 'webpage', label: 'Página web' },
    { name: 'action', label: 'Acciones', actions: ActionButtons },
  ];

  return (
    <>
      <Title variant="h5" component="h2">Archivos de salud</Title>
      <DataTable
        uri={uri}
        params={params}
        headers={tableHeaders}
        filters={<FilterBar onFilter={handleFilter} />}
      />
    </>
  );
}

Files.propTypes = propTypes;

export default Files;
